export interface CteCapabilities {
    /**
     * Are CTEs supported at all?
     */
    enabled: boolean

    /**
     * Are RETURNING clauses supported in CTEs?
     */
    writable?: boolean
    /**
     * Is RECURSIVE clause required for recursive CTEs?
     */
    requiresRecursiveHint?: boolean

    /**
     * Is MATERIALIZED clause supported?
     */
    materializedHint?: boolean
}
